import { MontoCRC } from '@/components/dominio/MontoCRC';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface Props {
  titulo: string;
  monto: number;
  subtitulo?: string;
  destacado?: boolean;
}

export function KpiCard({ titulo, monto, subtitulo, destacado }: Props) {
  const esNegativo = monto < 0;
  return (
    <Card className={cn(destacado && 'border-l-4 border-l-adelante-primary')}>
      <CardHeader className="pb-2 pt-4 px-4">
        <CardTitle className="text-xs uppercase tracking-wider text-muted-foreground">
          {titulo}
        </CardTitle>
      </CardHeader>
      <CardContent className="overflow-hidden px-4 pb-4">
        <MontoCRC
          monto={monto}
          className={cn('block truncate text-xl font-semibold', esNegativo && 'text-destructive')}
          titulo={monto}
          decimales={false}
        />
        {subtitulo && <p className="mt-1 text-xs text-muted-foreground">{subtitulo}</p>}
      </CardContent>
    </Card>
  );
}
